<template>
<div id="career-page">
	<content-view :color="color">
		<template slot="intro">
			<div class="center">
					<div class="text">
						<h1 v-collide="'fadeInLeft'">На пике формы</h1>
						<p v-collide="'fadeInUp'">
							Хочешь оказаться на пике своей карьерной формы? Получить работу мечты
							или долгожданное повышение, завоевать еще большее уважение у коллег
							или руководства? В этом тебе поможет Алена Владимирская – гуру российского
							хедхантинга и основатель проекта «Антирабство».
						</p>

						<div class="wrap">
							<img :src="getImg('intro-text-image.png')" v-collide="'fadeInUp'">
							<p v-collide="'fadeInRight'">
								Грамотный и сильный наставник, которая знает, как правильно
								построить карьеру с нуля или вдохнуть новую жизнь в старую.
								Алена подготовила для тебя персональные программы по карьерному
								росту, рассчитанные на 4 месяца. Чтобы получить их - просто
								оставить свой мейл. Готов? Тогда, вперед!
							</p>
						</div>
					</div>
			</div>
		</template>
		<template slot="programs">
				<div id="program-1" :class="{'visible': visible.first}">
					<div class="center">
						<div class="program-header">
							<div class="text">
								<div class="header">
									<h2 v-collide="'fadeInUp'">Программа 1</h2>
									<a v-if="!visible.first" class="button button-show" @click="visible.first = true">
										<span>Узнать подробнее</span>
									</a>
								</div>
								<h3 v-if="visible.first" v-collide="'fadeInUp'">Карьера</h3>
								<p v-if="visible.first" v-collide="'fadeInLeft'">Успех карьеры зависит от очень многих факторов - от микроэкономики и тенденций рынка труда, до, конечно же, самого человека: повлиять на мировую экономику мы не в состоянии, но есть вещи, которые напрямую зависят от нас.</p>
								<p v-if="visible.first" v-collide="'fadeInLeft'">Итак, сегодня у нас старт 4-недельного курса, и 4 упражнений, благодаря которым вы сможете иначе взглянуть на свою карьеру и стать успешнее</p>
							</div>
						</div>
						<div v-if="visible.first" class="program-blocks">
							<div class="program-block program-block-1" >
								<div class="row-with-picture">
									<div class="text" v-collide="'fadeInLeft'">
										<p>
											И наше первое упражнение на развитие «мягких  навыков» - то есть личностных качеств, которые  помогут в карьерном росте. Одним из основных считается навык умения выстраивать коммуникации.  Он не теряет актуальности уже много лет и является  одним из самых перспективных. Ведь никто не делает  масштабные и сложные проекты в одиночку - в них  всегда участвует команда, с которой надо уметь  говорить. Это значит не просто коммуницировать,  то есть поддерживать отношения, а делать их эффективными. Плохая коммуникация — причина  серьезного карьерного выгорания, а также появления проблем как в проектной деятельности, так и в работе команды в целом.
										</p>
									</div>
									<img :src="getImg('program-1-1.png')" v-collide="'fadeIn'">
								</div>
							</div>

							<div class="program-block program-block-2" >
								<div class="row-with-picture">
									<img :src="getImg('program-1-2.png')" v-collide="'fadeIn'">
								<div class="text" v-collide="'fadeInRight'">
									<ul>
										<li>
											<h5>
												<span>Задание 1</span>
											</h5>
											<p>Определите, с кем вы хотите выстроить эффективную
									коммуникацию, кто субъект вашего интереса.</p>
										</li>
										<li>
											<h5>
												<span>Задание 2</span>
											</h5>
											<p>
												Обозначьте цель коммуникации (например, если это ваш
												руководитель, возможно, ваша цель — это повышение или
												новые ресурсы для проекта).
											</p>
										</li>
										<li>
											<h5>
												<span>Задание 3</span>
											</h5>
											<p>
												Определите инструменты коммуникации, благодаря
												которым цель будет достигнута (отчеты, презентации,
												общение за ланчем — инструмент должен быть удобен
												и приемлем в первую очередь для того, с кем вы планируете выстраивать общение).
											</p>
										</li>
										<li>
											<h5>
												<span>Задание 4</span>
											</h5>
											<p>
												Работа в поле – то есть непосредственно само общение
												с учетом целей и использованием адекватных
												инструментов.
											</p>
										</li>
									</ul>
									<p>
										Не уверены в своих силах? Опробуйте их на коллегах,
										которые не являются ключевыми для достижения вашей
										цели. После того, как натренируетесь, идите
										непосредственно к ключевому коллеге.
									</p>
								</div>
								</div>
							</div>
						</div>
						<a @click="visible.first = false" v-collide="'fadeInLeft'" v-if="visible.first" class="button button-hide">
							<span>Скрыть</span>
						</a>
					</div>
					<Sides/>
				</div>

				<div id="program-2" :class="{'visible': visible.second}">
					<div class="center">
						<div class="program-header">
							<div class="text">
								<div class="header">
									<h2 v-collide="'fadeInUp'">Программа 2</h2>
									<a v-collide="'fadeInUp'" v-if="!visible.second" class="button button-show" @click="visible.second = true">
										<span>Узнать подробнее</span>
									</a>
								</div>
								<h3 v-if="visible.second" v-collide="'fadeInLeft'">Карьера</h3>
								<h6 v-if="visible.second" v-collide="'fadeInLeft'">Упражнение 2:  лучшее ПО в вашей области</h6>
								<div v-if="visible.second" v-collide="'fadeInLeft'">
									<p>В современном мире невозможно быть успешным, не зная технологий и специализированного ПО. Даже если вы не программист и развиваетесь в творческой или
									гуманитарной области, 99% вероятности, что есть ПО, которым регулярно
									пользуются ваши передовые коллеги. И да, это позволяет им быть впереди.</p>

									<p>Это может быть софт, помогающий организовать день, оптимизировать коммуникацию или синхронизировать работу с коллегами — например, ERP-системы,
									таск-менеджеры, средства управления проектами, облачные сервисы и многое
									другое.</p>

									<p>Владение современными технологиями резко повысит вашу стоимость на рынке
									труда и даст импульс к реорганизации работы. Готовы к переменам? Тогда перейдем к упражнениям.</p>
								</div>
							</div>
							<img v-if="visible.second" :src="getImg('program-2-1.png')" v-collide="'fadeIn'">
						</div>
						<div v-if="visible.second" class="program-blocks">
							<div v-collide="'fadeInRight'" class="program-block program-block-1">
								<div class="text">
									<h6>Задания по второму упражнению:</h6>
									<ul>
										<li>Зайдите на площадку с портфолио профессионалов в вашей области (это могут
										и отраслевые группы в соцсетях).</li>

										<li>Выберите 10 хорошо заполненных профилей профессионалов высокого уровня (того
										уровня, к которому вы стремитесь), или сотрудников лучших компаний в вашей сфере,
										или лидеров вашего профессионального сообщества.</li>

										<li>Выпишите все технологичные инструменты и ПО, указанные в их резюме, в перечне
										навыков и т.д.</li>

										<li>Из полученных результатов составьте топ с 3–5 программами, которые, что называется, must have для вашей сферы.</li>

										<li>Задайте себе простой вопрос: «Владею ли я этими программами?» Нет? Тогда срочно скачивайте, приобретайте и разбирайтесь — смотрите видеоуроки, идите на очный курс. Начать надо с первой, самой популярной программы, навыков работы с которой у вас нет.
										Остальные необходимо поставить в план на год.</li>

									</ul>
								</div>
							</div>
							<div  class="program-block program-block-2">
								<div class="row-with-picture">
									<img v-collide="'fadeInLeft'" :src="getImg('program-2-2.png')">
									<div class="text" v-collide="'fadeInRight'">
											<p>
												<strong>Лайфхак:</strong> вы можете дополнить свое исследование анализом профилей иностранных специалистов. Поскольку все технологии приходят с Запада, у вас есть неплохой шанс ухватить тренд до того, как он придет к нам в страну (и через пару лет стартовать, уже будучи специалистом в новом ПО). Также можно провести базовый анализ 10 вакансий от лучших компаний в вашей сфере — просто посмотреть, знание какого софта требует работодатель.
											</p>
											<p>
												Помните, что знание современных технологий поможет вам забраться на ступень выше в конкурентной борьбе за работу мечты. И, может быть, откроет перед вами новые возможности, о которых вы ранее и не задумывались!
											</p>
										</div>
								</div>
							</div>

						</div>
						<a v-collide="'fadeInRight'"
						   @click="visible.second = false"
						   v-if="visible.second"
						   class="button button-hide">
							<span>Скрыть</span>
						</a>
					</div>


					<Sides/>
				</div>
			</template>


			<template slot="programs_bottom">
				<div id="program-3" :class="{'visible': visible.third}">
					<div class="center">
						<div class="program-header">
							<div class="header">
								<h2 v-collide="'fadeInLeft'">Программа 3</h2>
								<a v-collide="'fadeInLeft'"  v-if="!visible.third" class="button button-show" @click="visible.third = true">
									<span>Узнать подробнее</span>
								</a>
							</div>
							<div class="text">

								<h3 v-collide="'fadeInLeft'"  v-if="visible.third" >Карьера</h3>
								<h6  v-collide="'fadeInLeft'"  v-if="visible.third">Упражнение 3. Нетворкинг: сообщество и личный бренд</h6>
								<p v-collide="'fadeInLeft'"  v-if="visible.third">
									Развитие личного бренда может дать необходимый импульс вашей карьере, стать
									лифтом для продвижения в компании или хорошим источником новых предложений.
									Личный бренд можно построить на ваших профессиональных достижениях, кейсах,
									творческих успехах или связать с брендом вашей компании.

									Поскольку мы говорим о профессиональном личном бренде, наша основная
									аудитория — сообщество профессионалов в вашей области или близких к ней
									специалистов. За счет развития личного бренда растет и ваша профессиональная
									сеть контактов, а это, в свою очередь, отличный инструмент для достижения
									множества целей, причем не только карьерных.

									Существует заблуждение, что личный бренд лучше строить только экспертам высокого уровня или людям с огромными достижениями, но это не совсем так. Личный бренд — это всего лишь известность в профессиональном кругу, которая может стать
									отправной точкой для дальнейших достижений. Так вы сможете зарекомендовать себя как крепкий специалист, можете делать профессиональную аналитику или обзоры,
									переводить зарубежные материалы. Ваша задача — оказаться на слуху, создать
									себе имя.

									Разумеется, личный бренд не строится за один день, он требует времени, обычно
									не меньше года. Поэтому, если вы хотите достичь ощутимых результатов, приниматься за строительство стоит как можно раньше, чтобы в нужный момент инструменты
									вашего личного бренда оказались в рабочем состоянии. Давайте займемся
									этим прямо сейчас!
								</p>
							</div>
							<img v-if="visible.third" :src="getImg('program-3-1.png')" v-collide="'fadeIn'">
						</div>
						<div v-if="visible.third" class="program-blocks">
							<div v-collide="'fadeInRight'" class="program-block program-block-1">
								<div class="text">
										<p>
											Определите свою аудиторию. Не стоит ограничиваться только коллегами по профессии, мыслите шире —
											вам интересны все специалисты вашей индустрии, а возможно, и смежных, если ваша профессиональная
											деятельность предполагает возможность работы в других отраслях. Однако будьте аккуратны, поскольку
											чрезмерно расширять свою аудиторию тоже не стоит: чем точнее вы ее определите, тем проще будет начать.
										</p>
										<p>
											Проведите аудит своих кейсов, достижений, интересного опыта и профессиональных выводов,
											которыми можно поделиться. Не думайте, что все ваши коллеги знают столько же, сколько и вы,
											это заблуждение. Во-первых, есть начинающие специалисты, для которых личный опыт старших
											коллег всегда ценен. Во-вторых, в разных компаниях может отличаться структура или специфика
											инструментов, поэтому всегда интересно посмотреть, как делают другие. Кстати, для руководителей
											или представителей смежных профессий ваши «банальные» кейсы могут стать целым откровением —
											особенно если они напрямую влияют на результаты работы других подразделений или всей компании.
										</p>
										<p>
											Определите основные площадки для развития личного бренда. В первую очередь это онлайн-сообщества
											на отдельных профессиональных сайтах и профессиональные группы в социальных сетях.
											Во вторую — офлайн-мероприятия, то есть профессиональные конференции и митапы, отраслевые
											выставки и прочее. Составьте список мероприятий, продумайте несколько тем и тезисы выступления к ним,
											предложите себя в качестве спикера. Не стоит стесняться: организаторы всегда заинтересованы в новых
											спикерах, ваш опыт будет им интересен. Но даже если вы не выступаете сами, обязательно ходите
											на эти мероприятия и ведите себя активно — задавайте вопросы спикерам, знакомьтесь и представляйте
											себя коллегам, фиксируйте эти контакты в соцсетях и последовательно расширяйте свой нетворкинг.
										</p>
									</div>
								</div>
							<div class="program-block program-block-2" >
								<div class="row-with-picture">
									<div v-collide="'fadeInLeft'" v-if="visible.third"  class="text">
										<p>
											Если вы начинающий оратор, проще всего выходить
											в публичное пространство через социальные сети
											и профессиональные группы в них. Начинать можно
											с комментариев и вопросов, после чего переходите
											к самостоятельным постам и кейсам для обсуждения.
											Наконец, можно переводить иностранные материалы,
											делиться своими наблюдениями о рынке
											или рассказывать о новых инструментах — все это
											очень интересно и будет востребовано сообществом.
										</p>
										<p>
											Практическое домашнее задание на ближайшие недели:
											вспомните свежий проект или кейс из своей практики
											и опишите его на своей страничке, например в Facebook.
											Или сразу идите в профессиональные группы,
											почему нет?
										</p>
										<a @click="visible.third = false" v-if="visible.third" class="button button-hide">
											<span>Скрыть</span>
										</a>
									</div>
									<img v-if="visible.third" :src="getImg('program-3-2.png')" v-collide="'fadeInRight'">
								</div>
							</div>
						</div>
					</div>
				</div>
				<Subscribe/>
				<Sides/>
			</template>
			<template slot="product">
				Новый KIA Sportage станет твоим проводником в мир, полный открытий
				и приключений, ведь это автомобиль - на пике формы! И в нем воплотились
				самые передовые инновации и продвинутые технологии, которые гарантируют
				максимальное удобство вождения и безопасность. Например, интеллектуальный
				круиз-контроль, который в пробках определяет скорость и расстояние до
				едущего впереди автомобиля, поддерживая безопасную дистанцию. Еще
				большего комфорта в дороге добавит система мониторинга слепых зон,
				предупреждающая водителя во время перестроения. И, наконец, удобная
				система помощи при выезде с парковки задним ходом, которая всегда
				предупредит о приближающихся автомобилях.
			</template>
	</content-view>
</div>
</template>


<script>
import ContentView from '@/components/ContentV2'
import Sides from '@/components/Sides'
import Subscribe from '@/components/Subscribe'
import { colors } from '@/data/pages'
import LINKS from '@/data/links';

export default {
	name: 'Career',
	components: {
		ContentView,
        Sides,
        Subscribe
	},
	data() {
		return {
            visible: {
                first: false,
                second: false,
                third: false
            },
			color: colors[this.$route.name],
		}
	},
	computed: {
        learnmoreLink() {
            return LINKS[this.route]
        },
	},
	methods: {

        getImg(name) {
            return require(`@/assets/images/${this.$route.name}/${name}`)
        },
	}
}
</script>

<style lang="less">
@import '../styles/variables';

#career-page {

	#program-1 {
		position: relative;
		z-index: 1;
		.program-header {
			h2 {
				display: block;
			}
			img {
				position: relative;
				width: calc(~'100% + 40px');
				z-index: 2;
				display: block;
				margin-top: 30px;
				@media (max-width: 959px) {
					left: -20px;
				}

				@media (min-width: 960px) {
					right: 0;
					width: 100%;
					max-width: 60%;
					margin-left: auto;

				}
			}

			.text {
				margin-top: 70px;
				margin-bottom: 30px;
				z-index: 3;
				position: relative;
				@media (min-width: 960px) {
					left: 10%;
					max-width: 70%;
					margin-bottom: 0;
				}
				&:before {
					content: "";
					display: block;
					position: absolute;
					right: -120px;
					top: -10px;
					width: 70px;
					height: 110px;
					background: url('../assets/images/arrows-top.png') no-repeat center center;
					background-size: contain;
				}
				&:after {
					content: "";
					display: block;
					position: absolute;
					left: 25%;
					top: -35%;
					width: 50%;
					height: 200%;
					background: url('../assets/images/dots-2.png') no-repeat center center;
					background-size: contain;
				}
			}

		}

		.sides {
			bottom: 0;
		}

		@media (min-width: 960px) {
			.program-block-1 {
				margin-top: 60px;
				margin-left: 10%;
				.text {
					padding-right: 40px;
				}
				img {
					max-width: 50%;
				}
			}

			.program-block-2 {
				margin-top: 60px;
				img {
					max-width: 50%;
				}
				.text {
					margin-left: 10%;
					max-width: 40%;
				}
			}
			.program-block-3 {
				margin-left: 37.5%;
				max-width: 57.5%;
			}
			.button {
				margin-left: 10%;
			}
		}
		.program-block-2 {
			ul {
				margin-bottom: 32px;
				h5 {
					font-size: 20px;
					margin: 0 0 -10px;
					font-family: @font-bold;
					span {
						position: relative;
						z-index: 1;
					}
				}
				p {
					font-size: 15px;
					margin-top: 10px;
					margin-bottom: 16px;
					position: relative;
					z-index: 1;
				}
				li {
					position: relative;
					&:after {
						color: #000;
						content: " ";
						position: absolute;
						top: -32px;
						left: 0;
						width: 100%;
						text-align: center;
						font-size: 64px;
						font-family: @font-bold;
					}
				}
				li:nth-child(1):after {
					content: "1";
				}
				li:nth-child(2):after {
					content: "2";
				}
				li:nth-child(3):after {
					content: "3";
				}
				li:nth-child(4):after {
					content: "4";
				}
			}
		}
		.program-block-3 {
			margin-top: 90px;
			margin-bottom: 90px;
		}
		.button {
			margin-bottom: 60px;
			&:after {
				display: none;
			}
		}
		.header {
			width: auto;
			display: inline-block;
			text-align: center;
			position: relative;
			&:after {
				content: "";
				display: block;
				width: 230px;
				height: 65px;
				background: #000;
				position: absolute;
				bottom: 38px;
				left: -120px;
			}
		}
		.button-show {
			left: 0;
			margin: 0 auto;
			display: inline-block;
		}
	}
	#program-2 {
		position: relative;
		z-index: 0;
		margin-bottom: 60px;
		@media (min-width: 960px) {
			margin-bottom: 0;
		}
		&:before {
			content: "";
			display: block;
			position: absolute;
			left: 20%;
			top: -320px;
			width: 60%;
			height: 920px;
			background: url('../assets/images/dots-1.png') no-repeat center center;
			background-size: contain;
		}
		&.visible:before {
			display: none;
		}
		&:after {
			content: "";
			display: block;
			position: absolute;
			right: -120px;
			top: -420px;
			width: 30%;
			height: 920px;
			background: url('../assets/images/dots-3.png') no-repeat center center;
			background-size: contain;
		}
		@media (min-width: 960px) {
			margin-top: -75px;
		}
		&.visible {
			margin: 0;
		}
		.program-header {
			img {
				position: relative;
				width: calc(~'100% + 40px');
				z-index: 2;
				display: block;
				margin-top: 30px;
				@media (max-width: 959px) {
					left: -20px;
				}

				@media (min-width: 960px) {
					left: 20%;
					width: 100%;
					max-width: 80%;

				}
			}

			.text {
				margin-bottom: 30px;
				z-index: 3;
				@media (min-width: 960px) {
					margin-left: 10%;
				}
				p {
					@media (min-width: 960px) {
						max-width: 50%;
						margin-bottom: 16px;
					}
				}
			}

			h2 {
				display: block;
			}

			p {
				position: relative;
				font-family: @font-light;
				font-size: 16px;
				z-index: 1;
			}
		}
		img {
			display: block;
			margin-top: 60px;
			width: 100%;
		}
		.header {
			width: auto;
			display: inline-block;
			text-align: center;
			white-space: nowrap;
			@media (min-width: 960px) {
				margin-left: 40%;
			}
		}
		.button {
			margin-top: 30px;
			margin-bottom: 30px;
			&:after {
				transform: skew(-45deg);
			}
			@media (min-width: 960px) {
				margin-top: 60px;
				margin-bottom: 120px;
			}
		}

		.program-block-1 {
			li {
				margin-bottom: 20px;
			}
		}

		@media (min-width: 960px) {

			.program-block-1 {
				margin-top: 90px;
				margin-left: 5%;
				max-width: 65%;
			}
			.program-block-2 {
				margin-bottom: 320px;
				img {
					width: 70%;
					position: relative;
					margin-left: -10%;
					top: -72px;
				}
				.text {
					padding-left: 5%;
				}
			}
			.button {
				position: absolute;
				right: 12.5%;
				bottom: 180px;
				margin-top: 0;
				margin-bottom: 0;
			}
			.button-show {
				position: relative;
				display: inline-block;
				bottom: 0;
				right: auto;
				margin: 0 auto;
				margin-bottom: 120px;
			}
		}
	}

	#banner {
		&:after {
			left: 60%;
			background: url('../assets/images/lines-white.png') no-repeat center center;
			background-size: contain;
		}
	}

	#program-3 {
		.program-header {
			position: relative;
			&:before {
				content: "";
				display: block;
				width: 320px;
				height: 65px;
				background: #000;
				position: absolute;
				top: 160px;
				left: -30px;
				transform: skew(-45deg);
			}

			img {
				position: relative;
				width: calc(~'100% + 40px');
				z-index: 2;
				display: block;
				margin-top: 30px;
				@media (max-width: 959px) {
					left: -20px;
					width: 100%;
				}

				@media (min-width: 960px) {
					left: 30%;
					width: 100%;
					max-width: 70%;

				}
			}

			.text {
				margin-top: 65px;
				@media (min-width: 960px) {
					left: 5%;
					max-width: 60%;
				}
			}

			.header {
				margin-top: 30px;
				font-size: 16px;
				position: relative;
				font-family: @font-light;
				@media (min-width: 960px) {
					text-align: center;
					left: 5%;
					width: 95%;
					max-width: 40%;
				}
			}
		}

		.button-show {
			display: inline-block;
		}
		@media (min-width: 960px) {
			.program-block-1 {
				margin-top: 90px;
				margin-left: 5%;
				max-width: 75%;
				margin-bottom: 0;
			}

			.program-picture-1 {
				margin-top: 35px;
				margin-bottom: 35px;
				max-width: 70%;
			}

			.program-block-2 {
				margin-top: 60px;
				margin-left: 5%;
				max-width: 95%;
				margin-bottom: 360px;
				.button {
					margin-top: 30px;
				}
				img {
					width: 60%;
				}
			}

		}
	}
	.programs-bottom-subscribe {
		.button {
			&:after {
				display: none;
			}
		}
	}
	.programs-bottom-forms {
		&:before {
			display: none;
		}
		.button {
			&:after {
				display: none;
			}
		}
		@media (min-width: 960px) {
			.inner {
				right: 10%;
			}
		}
		.inner {
			&:before {
				content: "";
				display: block;
				width: 230px;
				height: 65px;
				background: #000;
				position: absolute;
				top: 45px;
				left: -30px;
			}
			h2 {
				position: relative;
			}
		}
	}
}
</style>
